import {useEffect} from 'react'
import { useLocation } from 'react-router-dom';

import { useKeycloak } from "../../../auth";
import { clearStorage } from "../../config/storageConfig";

export default function Logout () {
  
  const { keycloak } = useKeycloak();
  const location = useLocation();
  const from = location.state?.from || window.location.origin;

  useEffect(() => {
    clearStorage();
    keycloak.logout({redirectUri: from});
  });
  return (
    <></>
  );
}
